import React from 'react'
import { InputBase, Paper, Button, Typography } from '@material-ui/core'
import { Check, HighlightOff } from '@material-ui/icons'

import classes from './CustomUploadButton.module.scss'
export default function CustomUploadButton(props) {
  const { label = '', name, setValue, mainValue, setButtonColor, setIndexGetterFile, buttonColor, required, index = 100, readOnly, onClick, constainerStyle = {}, error, onChange, setSelectedFile, setFileError, fileError, type, placeholder, ...other } = props
  const { value = '' } = props

  const [_error, setError] = React.useState()
  React.useEffect(() => {
    setError()
    if (typeof value === 'string') {
      if (!value.trim()) setError(error)
    }
    if (typeof value === 'number') {
      if (value <= 0) setError(error)
    }
    if (!props.value) {
      setFileError('')
      setButtonColor('red')
    } else {
      setButtonColor('green')
    }
    if (fileError === 'correct') {
      setButtonColor('green')
    } else {
      setButtonColor('red')
    }
  }, [error, value])
  React.useEffect(() => {
    if (setIndexGetterFile) {
      setIndexGetterFile(index)
    }
  }, [index])
  const inputStyle = {
    fontSize: '14px',
  };

  const handleOnChange = e => {
    setError()
    if (typeof onChange === 'function') onChange(e)
  }

  const handleOnClickWrong = () => {
    setSelectedFile({})
    setValue({
      ...mainValue,
      selectedFile: ''
    })
  }


  return (
    <div className={classes.root} style={constainerStyle}>
      <Typography variant='subtitle2' className={classes.label}>
        {label}
        {!readOnly && required ? ' *' : ''}
      </Typography>
      <div className={classes['button-container']}>
        <input
          className={classes['file-upload-input']}
          type='file'
          style={{ display: 'none' }}
          name='file'
          index={index}
          multiple
          accept='.pdf'
          id='button-for-upload-file'
          onChange={handleOnChange}
        />
        <label htmlFor='button-for-upload-file'>
          <div className={classes.container}>
            <Button
              variant='raised'
              component='span'
              onClick={onClick}
              className={classes.button}
              style={{ backgroundColor: buttonColor }}
            >
              Upload File
            </Button>
            {props.value ? ('') : (
              <Typography className={classes.placeholder}>{placeholder}</Typography>
            )}
          </div>
        </label>
      </div>
      <div className={classes.wrapper}>
        {readOnly ? (
          <React.Fragment>
            <div className={classes.container}>
              <Typography id={props.id} variant='subtitle2' className={`${classes.label} ${classes['read-only-value']}`}>
                {props.value}
              </Typography>
              {fileError === 'correct'
               ? <Check style={{ color: 'green' }} className={classes.icon} />
                : fileError === 'wrong'
                 ? <div className={classes['wrong-icon-container']}>
                   <HighlightOff className={classes['wrong-icon']} />
                   <Typography className={classes['wrong-icon-label']}>Click again and change the file...</Typography>
                   </div> : ('')}
            </div>
            {_error && <span className={classes.error}>{_error}</span>}
          </React.Fragment>
        ) : ('')}
      </div>
    </div>
  )
}
